import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import protocol_inside from "./protocol_inside.vue";

window.tenderProtocol = createApp({
    name : "ProtocolInside",
    id : "ProtocolInside",
    components : {
        protocol_inside : protocol_inside,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

tenderProtocol.mount('#protocolInside');